<script>
  import { fetchVehicles, sortRdwResults } from 'utils';
  import { lpInfo } from "constants";
  import { onMount } from 'svelte';
  import { Button, TextField, ProgressLinear } from "smelte";
  import VehicleItem from 'components/licenseplate/VehicleItem.svelte';
  let foundVehicles = [];
  let formFilter = {};
  let formLicenseplate = "";
  let formQueryType = "startmet";
  let formVehicleMake, formVehicleType, formVehicleTypeSub, formVehicleColor;
  let timeSearched = 0;
  let currentlySearching = false;
  let startTime, endTime;
  $: formLicenseplate = formLicenseplate.toUpperCase();
    
  function startSearching() {
    currentlySearching = true;
    timeSearched = 0;
    startTime = new Date();
  };
  
  function endSearching() {
    currentlySearching = false;
    endTime = new Date();
    let timeDiff = endTime - startTime; //in ms
    timeDiff /= 1000;
    timeSearched = Number(timeDiff).toFixed(2); // remove digits
    // console.log(timeSearched + " seconds");
  };

  function getVehiclesFromRdw() {
    // ignore default values
    if (!formVehicleMake.includes("optioneel")) {
      formFilter.merk = formVehicleMake;
    };
    if (!formVehicleColor.includes("optioneel")) {
      formFilter.eerste_kleur = formVehicleColor;
    };
    if (!formVehicleType.includes("optioneel")) {
      formFilter.voertuigsoort = formVehicleType;
    };
    if (!formVehicleTypeSub.includes("optioneel")) {
      formFilter.inrichting = formVehicleTypeSub;
    };
    if (formLicenseplate === "") {
      return false;
    }
    startSearching();
    let resultVehicles, sortedVehicles;
    let result = fetchVehicles(formFilter, { kenteken: formLicenseplate, type: formQueryType })
    .then(resultVehicles =>
      sortRdwResults(resultVehicles)
    ).then(sortedVehicles =>
      loadResults(sortedVehicles)
    );
  };

  function loadResults(results) {
    endSearching();
    foundVehicles = results;
  };

  
</script>

<main>
  <div class="mx-2">  
    <h1 class="text-xl font-bold">
      Kentekens
    </h1>

    <div class="mb-2">
      <form on:submit|preventDefault={getVehiclesFromRdw}>
        <div class="sm:col-span-3">
          <label for="formLicenseplate" class="block text-sm font-medium text-gray-700">
            Kenteken of deel van kenteken:
          </label>
          <label class="text-sm font-medium text-gray-900">
            <input type=radio bind:group={formQueryType} value="startmet">
            start met
          </label>
          <label class="text-sm text-gray-900">
            <input type=radio bind:group={formQueryType} value="bevat">
            bevat
          </label>
          <div class="mt-1">
            <TextField bind:value={formLicenseplate} label="kenteken" size=20 spellcheck="false" hint="bijv. G405% of %405% (% voor onbekende karakters)" maxlength="8" name="formLicenseplate" id="formLicenseplate" persistentHint color="blue" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
          </div>
        
        <select bind:value={formVehicleMake}>
          {#each lpInfo.vehicle_make as make}
            <option value={make.merk}>
              {make.merk}
            </option>
          {/each}
        </select>

        <select bind:value={formVehicleColor}>
          {#each lpInfo.vehicle_colors as color}
            <option value={color.eerste_kleur}>
              {color.eerste_kleur}
            </option>
          {/each}
        </select>

        <select bind:value={formVehicleType}>
          {#each lpInfo.vehicle_type as type}
            <option value={type.voertuigsoort}>
              {type.voertuigsoort}
            </option>
          {/each}
        </select>

        <select bind:value={formVehicleTypeSub}>
          {#each lpInfo.vehicle_type_sub as typeSub}
            <option value={typeSub.inrichting}>
              {typeSub.inrichting}
            </option>
          {/each}
        </select>
        
        <Button type="submit">Zoek</Button>
        <div class="mt-2 mb-2">
          {#if currentlySearching}
          <ProgressLinear />
          {/if}
        </div>
      </form>

      <div class="text-sm font-medium text-gray-900">
        {#if foundVehicles.length > 0}
          {foundVehicles.length} {foundVehicles.length === 1 ? "voertuig" : "voertuigen"} gevonden in {timeSearched} seconden
        {/if}
      </div>

      <div class="flex flex-col">
        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th scope="col" class="px-2 py-2 text-left text-xs text-gray-500 uppercase tracking-wider">
                      Kenteken
                    </th>
                    <th scope="col" class="px-2 py-2 text-left text-xs text-gray-500 uppercase tracking-wider">
                      Merk
                    </th>
                    <th scope="col" class="px-2 py-2 text-left text-xs text-gray-500 uppercase tracking-wider">
                      Type
                    </th>
                    <th scope="col" class="px-2 py-2 text-left text-xs text-gray-500 uppercase tracking-wider">
                      Kleur
                    </th>
                    <th scope="col" class="px-2 py-2 text-left text-xs text-gray-500 uppercase tracking-wider">
                      Inrichting
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {#each foundVehicles as resultVehicle, i}
                    <VehicleItem vehicleItem={resultVehicle} index={i} />
                  {/each}      
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<style>

</style>